export default class POSService {
  constructor (http, store, router) {
    this.$http = http
    this.$store = store
    this.$router = router
  }

  getPOSes () {
    return new Promise((resolve, reject) => {
      this.$http.get('poses')
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  createPOS (data) {
    return new Promise((resolve, reject) => {
      this.$http.post('poses/store', data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  updatePOS (id, data) {
    return new Promise((resolve, reject) => {
      this.$http.post(`poses/update/${id}`, data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  deletePOS (id) {
    return new Promise((resolve, reject) => {
      this.$http.delete(`poses/delete/${id}`)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  changePOSStatus (id) {
    return new Promise((resolve, reject) => {
      this.$http.post(`poses/status/${id}`)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  changeStore (posId, storeId) {
    return new Promise((resolve, reject) => {
      this.$http.post(`poses/${posId}/store/${storeId}`)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }
}
